import { render, staticRenderFns } from "./ProviderSummary.vue?vue&type=template&id=18d89036"
import script from "./ProviderSummary.vue?vue&type=script&lang=js"
export * from "./ProviderSummary.vue?vue&type=script&lang=js"
import style0 from "./ProviderSummary.vue?vue&type=style&index=0&id=18d89036&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports